<template>
	<v-dialog
		v-model="dialog"
		:max-width="dialogWidth"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">インポート元製品検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-row no-gutters class="pa-2" justify="space-around">
				<v-file-input label="CSVアップロード" @change="getFileContent" />
			</v-row>
			<v-row no-gutters class="pa-2" justify="space-around" v-if="importOrderComponents.length > 0">
				<table>
					<thead>
						<tr>
							<th>品番</th>
							<th>品名</th>
							<th>数量</th>
							<th>単価</th>
							<th>備考</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(oc, index) in importOrderComponents" :key="'ioc-' + index">
							<td>{{ oc.number }}</td>
							<td>{{ oc.name }}</td>
							<td>{{ oc.quantity }}</td>
							<td>
								{{ oc.unit_price ? oc.unit_price.toLocaleString() : "" }}
							</td>
							<td class="pre-wrap text-left" v-text="oc.remarks"></td>
						</tr>
					</tbody>
				</table>
			</v-row>
			<v-row no-gutters class="pa-2" justify="space-around">
				<v-btn class="mt-2 mx-1" @click="createOrderComponents()"
					><v-icon>mdi-set-merge</v-icon>上記の部品をインポートする</v-btn
				>
				<v-btn class="mt-2 mx-1" @click="closeDialog()"><v-icon>mdi-close</v-icon>キャンセル</v-btn>
			</v-row>
			<v-card-actions>
				<v-row no-gutters class="pb-2"> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import Encoding from "encoding-japanese"

export default {
	data() {
		return {
			dialogWidth: "600px",
			common: common,
			dialog: false,
			targetOrderedProductId: null,
			importOrderComponents: [],
			uploadedFlag: false,
			uploadFile: null,
		}
	},
	methods: {
		orderedProductInfo(op) {
			return (
				"製造番号：" +
				op.product_number +
				"\n製品名　：" +
				op.product.name +
				"\n数量　　：" +
				op.quantity
			)
		},
		openDialog(id) {
			this.dialog = true
			this.targetOrderedProductId = id
		},
		closeDialog() {
			this.dialog = false
			this.targetOrderedProductId = null
			this.importOrderComponents = []
			this.uploadedFlag = false
			this.uploadFile = null
		},
		async getFileContent(file) {
			try {
				const content = await this.csvLoad(file)
				let rows = content.replace("'", "").replace('"', "").replace("\r", "").split("\n")
				let datum = []
				rows.forEach((row, index) => {
					if (index != 0) {
						const fields = row.split(",")
						const hash = {
							number: fields[0],
							name: fields[1],
							remarks: fields[2],
							unit_price: fields[3],
							quantity: fields[4],
						}
						datum.push(hash)
					}
				})
				this.importOrderComponents = datum
			} catch (e) {
				console.log(e)
			}
		},
		csvLoad(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => {
					//文字列をバイト列に変換
					var sjisArray = new Uint8Array(reader.result)
					//encode.jsを使い、文字コードを自動判別しUNICODEへ変換
					var unicodeArray = Encoding.convert(sjisArray, {
						to: "UNICODE",
						from: "AUTO",
						type: "string",
					})
					resolve(unicodeArray)
				}
				reader.onerror = reject
				reader.readAsArrayBuffer(file)
			})
		},
		createOrderComponents() {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			const config = { headers: { "content-type": "multipart/form-data" } }
			formData.append("ordered_product_id", this.targetOrderedProductId)
			formData.append("csvOrderComponents", JSON.stringify(this.importOrderComponents))
			axios
				.post("/erp/v1/parts_list/csv_import.json", formData, { headers })
				.then((response) => {
					let view_sentence = ""
					if (response.data.create_count > 0) {
						view_sentence =
							response.data.import_count +
							"件の部品をインポートしました" +
							"\n" +
							response.data.create_count +
							"件の部品を新規作成しました"
					} else {
						view_sentence = response.data.import_count + "件の部品をインポートしました"
					}
					this.$store.commit("setFlash", {
						text: view_sentence,
						type: "notice",
					})
					if (response.data.error_number) {
						this.$store.commit("setFlash", {
							text: response.data.error + "件のインポートに失敗しました",
							type: "alert",
						})
					}
					this.closeDialog()
					this.$emit("reloadIndex")
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		searchOrderedProducts() {
			let th = this
			async function main() {
				let response = await th.common.searchOrderedProducts(th.searchWord)
				th.searchedOrderedProducts = response.data.ordered_products
				if (th.searchedOrderedProducts.length == 0) {
					th.noResultFlag = true
				} else {
					th.noResultFlag = false
				}
			}
			main()
		},
		setOrderedProduct(orderedProduct) {
			this.selectedOrderedProduct = orderedProduct
			this.searchedOrderedProducts = []
			this.searchWord = ""
		},
	},
	watch: {
		statusIdsHash() {
			if (this.statusIdsHash != null) {
				let keys = Object.keys(this.statusIdsHash)
				keys.forEach((key) => {
					this.statusAndJapanese.push({
						text: this.statusIdsHash[key],
						value: key,
					})
				})
			}
		},
	},
	computed: {},
}
</script>
<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
.w100p {
	width: 100%;
}
table {
	border-collapse: separate;
	text-align: center;
	max-height: 1000px;
}
th,
td {
	border: 1px gray solid;
	padding: 3px;
	background: white;
}
tr {
	border-bottom: solid 1px gray;
}
th {
	background-color: $sub-color;
	color: #fff;
	min-width: 110px;
	text-align: center;
	position: sticky;
	top: 0;
}
.firstIsColored {
	&:first-child {
		td {
			background-color: $sub-color;
			color: #fff;
			min-width: 110px;
			text-align: center;
			position: sticky;
			top: 0;
		}
	}
}
</style>
